/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Rest_TitleInputs */

const en_us2_recovery_rest_title = /** @type {(inputs: Recovery_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest is training too`)
};

const pt_br2_recovery_rest_title = /** @type {(inputs: Recovery_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso também é treino`)
};

const es_419_recovery_rest_title = /** @type {(inputs: Recovery_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descansar también es entrenar`)
};

const pt_pt2_recovery_rest_title = /** @type {(inputs: Recovery_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descansar também é treinar`)
};

const fr_fr2_recovery_rest_title = /** @type {(inputs: Recovery_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le repos, c'est aussi de l'entraînement`)
};

const de_de2_recovery_rest_title = /** @type {(inputs: Recovery_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause ist auch Training`)
};

const it_it2_recovery_rest_title = /** @type {(inputs: Recovery_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anche il riposo è allenamento`)
};

/**
* | output |
* | --- |
* | "Rest is training too" |
*
* @param {Recovery_Rest_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_rest_title = /** @type {((inputs?: Recovery_Rest_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Rest_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_rest_title(inputs)
	if (locale === "es-419") return es_419_recovery_rest_title(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_rest_title(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_rest_title(inputs)
	if (locale === "de-DE") return de_de2_recovery_rest_title(inputs)
	if (locale === "it-IT") return it_it2_recovery_rest_title(inputs)
	return en_us2_recovery_rest_title(inputs)
});
export { recovery_rest_title as "recovery.rest_title" }